import WxmChainEditCarousel from './src/main.vue';

WxmChainEditCarousel.install = function(Vue){
    Vue.component(WxmChainEditCarousel.name , WxmChainEditCarousel)
};

if (typeof window !== 'undefined' && window.Vue) {
    WxmChainEditCarousel.install(window.Vue);
}
export default WxmChainEditCarousel;